module.exports = __webpack_public_path__ + "assets/retina_Angle45Detailed.c49bfdc760979cfe9b9b7cb841c0c35b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Angle45Detailed.png
// module id = 615
// module chunks = 0